import SupportLink from "psims/react/components/support-link";

const UnknownError = () => {
    return <p>
        Please try again. If not successful, contact the department at <SupportLink>petroleum.statistics@dcceew.gov.au</SupportLink>.
    </p>;
}

export default UnknownError;